import React from 'react';
export function Hero() {
  return <section className="relative px-6 py-12 pb-10 sm:py-20 sm:pb-16 text-center" data-id="element-170">
      {/* Radial glow background */}
      <div className="pointer-events-none absolute left-1/2 top-0 h-[600px] w-[600px] -translate-x-1/2 bg-[radial-gradient(ellipse,rgba(201,168,76,0.08)_0%,transparent_70%)]" data-id="element-171" />

      <div className="mx-auto max-w-[800px] relative z-10" data-id="element-172">
        <div className="mb-7 inline-block rounded border border-gold/25 bg-gold/10 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold" data-id="element-173">
          Sistema N°1 en Argentina · Joyería y Oro
        </div>

        <h1 className="mb-6 font-serif text-[clamp(30px,6vw,52px)] font-black leading-[1.15] text-white" data-id="element-174">
          Tu negocio de joyas y oro
        </h1>

        <img src="https://cdn.magicpatterns.com/uploads/oc1AqSsBdj8M8ZSi5McqkG/MOCKUP_PRINCIPAL.png" alt="Megapack Negocio de Oro Mockup" width={480} height={480} decoding="async" fetchPriority="high" className="mx-auto mb-3 block aspect-square w-[70%] max-w-[480px] rounded-2xl object-contain" data-id="element-175" />

        <p className="mb-8 text-[12px] font-medium uppercase tracking-[0.18em] text-gold" data-id="element-176">
          resuelto en 30 días.
        </p>

        <p className="mx-auto mb-9 max-w-[560px] text-[17px] leading-[1.65] text-text" data-id="element-177">
          El sistema completo para pasar de{' '}
          <strong className="font-bold text-white" data-id="element-178">
            "no sé por dónde empezar"
          </strong>{' '}
          a tener tu primer negocio de joyas y oro funcionando — con proveedores
          reales, precios claros y tu primera venta cobrada.
        </p>

        <a href="https://solucionesya.shop/cart/48819517128952:1" target="_blank" rel="noopener noreferrer" className="mb-5 inline-block rounded-md bg-gold px-10 py-[18px] font-sans text-[15px] font-bold tracking-[0.04em] text-[#111] no-underline transition-all duration-200 hover:-translate-y-0.5 hover:bg-gold-light" data-id="element-179">
          💥 QUIERO MI NEGOCIO DE ORO RESUELTO AHORA
        </a>

        <div className="flex flex-wrap items-center justify-center gap-6 text-[12px] tracking-[0.06em] text-muted" data-id="element-180">
          <span data-id="element-181">PDF digital</span>
          <div className="h-[3px] w-[3px] rounded-full bg-border" data-id="element-182" />
          <span data-id="element-183">Acceso Inmediato</span>
          <div className="h-[3px] w-[3px] rounded-full bg-border" data-id="element-184" />
          <span data-id="element-185">Principiante → Vendedor</span>
          <div className="h-[3px] w-[3px] rounded-full bg-border" data-id="element-186" />
          <span data-id="element-187">Garantía 7 días</span>
          <div className="h-[3px] w-[3px] rounded-full bg-border" data-id="element-188" />
          <span data-id="element-189">Mercado Pago</span>
        </div>

        <div className="mt-7 flex flex-wrap justify-center gap-2" data-id="element-190">
          {['8 Tomos', '3 Bonos', 'Proveedores Verificados', 'Planillas Listas', 'Guiones de Venta', 'Ferias y Mercados'].map(tag => <span key={tag} className="rounded border border-border bg-card px-3 py-1.5 text-[11px] tracking-[0.06em] text-muted" data-id="element-191">
              {tag}
            </span>)}
        </div>
      </div>
    </section>;
}